"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emailFieldDelimetersRegex = void 0;
exports.emailFieldDelimetersRegex = /[\s,;]+/;
